import { call, put, select } from "redux-saga/effects";
import sendRetargeting from "@gcloud-npm/adabyron.misc.send-retargeting";
import FrontSonda from "@gcloud-npm/utils.monitoring.front-sonda";
import { actions as retargetingActions } from "@/reducers/retargeting";
import { RECAPTCHA_KEY, recaptchaActions } from "@/constants/constants";

const contextStore = (state) => state.main.context;

const getClientsIds = (context) => {
  const { clientIDs } = { ...context };
  const { ga: client_id, sessionId: session_id } = { ...clientIDs };
  const ga = {};

  if (client_id) {
    ga.client_id = client_id;
  }

  if (session_id && client_id) {
    const gaRegex = /^\d+\.\d+$/;
    if (gaRegex.test(client_id)) {
      ga.session_id = session_id;
    }
  }

  if (Object.keys(ga).length > 0) {
    return JSON.stringify(ga);
  }

  return "";
};

const getReCaptchaToken = ({ action = "default" }) => {
  return new Promise((resolve) => {
    if (typeof window === "undefined" || !window.grecaptcha) {
      resolve(null);
      return;
    }

    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(RECAPTCHA_KEY, { action }).then((token) => {
        resolve(token);
      });
    });
  });
};

const reportJSError = (error, processName, filePath, context) => {
  try {
    if (error instanceof Error) {
      const sonda = new FrontSonda({
        processName,
        filePath,
        context,
      });
      sonda.errorMessage({ error });
    }
  } catch (e) {
    // Nothing to do
  }
};

export function* sendRetargetingSaga({ payload }) {
  const contextApi = yield select(contextStore);

  try {
    const { contextURL } = { ...contextApi };
    const dataPayload = {
      campaign: {
        id: "ret-solar-lead",
        externalId: "",
      },
      products: [],
      context: {
        url: btoa(contextURL || window.location.href),
        ga: getClientsIds(contextApi),
      },
      contactInfo: {
        ...payload.data,
      },
    };
    const recaptchaToken = yield call(getReCaptchaToken, {
      action: recaptchaActions.RETARGETING,
    });
    yield call(sendRetargeting, {
      data: { ...dataPayload, recaptchaToken },
      context: contextApi,
    });
    yield put(retargetingActions.sendRetargetingSuccess());
  } catch (error) {
    reportJSError(error, "retargeting", "sagas/retargeting-sagas", contextApi);
    yield put(retargetingActions.sendRetargetingFailure());
  }
}
